/* eslint-disable array-callback-return */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ViedocButtonElement,
  ViedocDialogElement,
  ViedocMenuItemElement,
  ViedocRadioElement,
  ViedocSelectElement,
  ViedocTextareaElement,
} from "../../../../secure/elements/ViedocReactElements";

import { useSelector, useDispatch } from "react-redux";
import * as documentActions from "../../../../store/actions/documentActions";
import * as templateActions from "../../../../store/actions/templateActions";
import _ from "underscore";
import APP_CONST from "../../../shared/constants";

const DocumentActionModal = ({
  setDocActionObj,
  docDetailsList,
  setdocDetailsList,
  setActionText,
  actionText,
  setActionId,
  setCommentListArray,
  setIsActionLoading,
  setIsAwaitingFlagged,
  setAddedComments,
  setIsEditMode,
  setIsNewVersionCreated,
  setNewVersionType,
  isNewVersionCreated,
  latestDocVersion,
  selectedArtifactDetails,
  setIsDocVisible,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { reviewerAction, docShareCount } = useSelector(
    (store) => store.document
  );
  const { settings } = useSelector((store) => store.template);
  const [selectedAction, setSelectedAction] = useState("Select action");
  let actionArray = [];

  const actionListArray = [
    APP_CONST.TEXT_ADDCOMMENT,
    APP_CONST.TEXT_ADDNOTE,
    APP_CONST.TEXT_CREATE_NEW_VERSION,
    APP_CONST.TEXT_UNLOCKDOC,
    APP_CONST.TEXT_DELETEDOC,
    APP_CONST.TEXT_APPROVE,
  ];

  let payload = {
    searchKey: "",
    site: "ALL",
    countryCode: "ALL",
    pageCount: 0,
    pageSize: 20000,
    pageNumber: 1,
    milestoneGroup: "ALL",
    milestoneId: "",
    sectionid: "",
    category: "",
    lastdocumentupdatedon: sessionStorage.getItem("lastdocumentupdatedon"),
  };

  const getAction = (action) => {
    switch (action) {
      case "Add review comment":
        return t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT");
      case "Add note":
        return t("TMF.REVIEWPOPUP_ADDNOTE");
      case "Approve":
        return t("TMF.TEXT_APPROVE");
      case "Create new version":
        return t("TMF.BUTTON_CREATE_NEW_VERSION");
      case "Lock document":
        return t("TMF.REVIEWPOPUP_LOCKDOCUMENT");
      case "Unlock document":
        return t("TMF.REVIEWPOPUP_UNLOCKDOCUMENT");
      case "Delete document":
        return t("TMF.REVIEWPOPUP_DELETEDOCUMENT");
      default:
        break;
    }
  };

  const actionDropdownValues = reviewerAction.map((item) => {
    actionArray = {
      ...actionArray,
      value: item.action,
      label: getAction(item.action),
      id: item.id,
      disabled: false,
      displayAction: true,
    };

    return actionArray;
  });
  const actionLabels = actionDropdownValues.map(({ label }) => label);

  const filteredActionDropdownValues = actionDropdownValues.filter(
    ({ label }, index) => !actionLabels.includes(label, index + 1)
  );

  const [copyVersion, setCopyVersion] = useState(false);
  const [uploadVersion, setUploadVersion] = useState(false);

  const radioVersionArray = [
    {
      id: 1,
      checked: copyVersion,
      class: "tmfside-checkbox",
      value: "copy-version",
      label: `${t("TMF.TEXT_COPYFILECURRENTVERSION")} (${
        docDetailsList.documentsystemversion
      })`,
    },
    {
      id: 2,
      checked: uploadVersion,
      value: "upload-version",
      class: "tmfside-checkbox mb-10",
      label: t("TMF.TEXT_UPLOADNEWFILE"),
    },
  ];

  const onHide = (e) => {
    e.stopPropagation();
    setDocActionObj(false);
  };

  const handleSelectedAction = (event) => {
    const { value } = event.target;
    setActionText("");
    setSelectedAction(value);
    const filteredActionId = actionDropdownValues.find(
      (action) => action.value === value
    ).id;
    setActionId(filteredActionId);
    setCopyVersion(false);
    setUploadVersion(false);
  };

  const actionHandler = async () => {
    let payloadData = {};
    if (selectedAction === APP_CONST.TEXT_ADDCOMMENT) {
      const { documentid, documentversionguid } = docDetailsList;
      payloadData = {
        documentid: documentid,
        documentversionguid: documentversionguid,
      };
      docDetailsList.status = APP_CONST.TEXT_FLAGGEDBYQC;
      setdocDetailsList({ ...docDetailsList });
      setCommentListArray((props) => [...props, { comment: actionText }]);
      setAddedComments((prevState) => prevState + 1);
      setIsAwaitingFlagged(true);
    } else if (
      selectedAction === APP_CONST.TEXT_LOCKDOC ||
      selectedAction === APP_CONST.TEXT_UNLOCKDOC
    ) {
      payloadData.documentId = docDetailsList.documentid;
      payloadData.sectionId = docDetailsList.sectionid;
      payloadData.unlockReason = actionText;

      payloadData.origiartifactid = docDetailsList.origiartifactid;
      payloadData.lastmodifiedon = docDetailsList.lastmodifiedon;
      payloadData.documentversionguid = docDetailsList.documentversionguid;
      payloadData.setIsActionLoading = setIsActionLoading;
      payloadData.setdocDetailsList = setdocDetailsList;
      payloadData.docDetailsList = docDetailsList;
      dispatch(documentActions.fetchDocumentLock(payloadData));
    } else if (selectedAction === APP_CONST.TEXT_DELETEDOC) {
      payloadData.id = docDetailsList.documentid;
      payloadData.lastModifiedOn = docDetailsList.lastmodifiedon
        ? docDetailsList.lastmodifiedon
        : docDetailsList.createdon;
      payloadData.documentVersionGuid = docDetailsList.documentversionguid;
      payloadData.reason = actionText;
      payloadData.origiartifactid = docDetailsList.origiartifactid;
      payloadData.sectionOrigid = docDetailsList.sectionid;
      dispatch(documentActions.deleteDocument(payloadData));
      document.getElementById("doc-view-popup")?.hide();
    } else if (selectedAction === APP_CONST.TEXT_ADDNOTE) {
      const addNotePayload = {
        documentId: _.isEmpty(docDetailsList.tmfdropzoneid)
          ? docDetailsList.documentid
          : APP_CONST.HARD_CODED.dummyId,
        documentversionid: _.isEmpty(docDetailsList.tmfdropzoneid)
          ? docDetailsList.documentversionguid
          : APP_CONST.HARD_CODED.dummyId,
        notes: [actionText],
        tmfdropzoneid: docDetailsList.tmfdropzoneid
          ? docDetailsList.tmfdropzoneid
          : APP_CONST.HARD_CODED.dummyId,
      };
      dispatch(
        documentActions.addDocNote(
          addNotePayload,
          docDetailsList.origiartifactid
        )
      );

      dispatch({ type: "AGGRID_GET_CALL", payload: payload });
    } else if (selectedAction === APP_CONST.TEXT_APPROVE) {
      payloadData.documentId = docDetailsList.documentid;
      payloadData.sectionId = docDetailsList.sectionid;

      payloadData.origiartifactid = docDetailsList.origiartifactid;
      payloadData.lastmodifiedon = docDetailsList.lastmodifiedon;
      payloadData.workflowState = docDetailsList.status;
      payloadData.workflowAction = APP_CONST.TEXT_APPROVE;
      payloadData.documentversionguid = docDetailsList.documentversionguid;
      payloadData.setIsActionLoading = setIsActionLoading;
      payloadData.setdocDetailsList = setdocDetailsList;
      payloadData.docDetailsList = docDetailsList;
      dispatch(
        documentActions.documentStatusChange(
          payloadData,
          "",
          settings.islockdoconapproveenabled
        )
      );
    } else if (selectedAction === APP_CONST.TEXT_CREATE_NEW_VERSION) {
      const newVersionPayload = {
        documentid: docDetailsList.documentid,
        lastmodifiedon: docDetailsList.lastmodifiedon,
        iscreatenewversionfileupload: uploadVersion,
      };
      let docStatusPayload = {};
      docStatusPayload.payload = newVersionPayload;
      docStatusPayload.docDetailsList = docDetailsList;
      docStatusPayload.setdocDetailsList = setdocDetailsList;
      dispatch(templateActions.cloneDocNewVersion(docStatusPayload));
      setIsEditMode(true);
      setIsNewVersionCreated(true);
      setIsDocVisible(false);
    }
    document.getElementById("document-action")?.hide();
  };

  const versionHandler = (event) => {
    const { value } = event.target;
    if (value === "copy-version") {
      setCopyVersion(true);
      setUploadVersion(false);
    } else if (value === "upload-version") {
      setUploadVersion(true);
      setCopyVersion(false);
    }
    setNewVersionType(value);
  };

  const getActionField = () => {
    switch (selectedAction) {
      case APP_CONST.TEXT_ADDCOMMENT:
        return (
          <ViedocTextareaElement
            label={t("TMF.TEXT_COMMENT")}
            value={actionText}
            onChange={(e) => setActionText(e.target.value.trimStart())}
          />
        );
      case APP_CONST.TEXT_ADDNOTE:
        return (
          <ViedocTextareaElement
            label={t("TMF.TEXT_ADDNOTETEXT")}
            value={actionText}
            onChange={(e) => setActionText(e.target.value.trimStart())}
          />
        );
      case APP_CONST.TEXT_CREATE_NEW_VERSION:
        return (
          <div className="d-flex flex-dir-col gap-10 f14">
            {radioVersionArray.map((radio) => (
              <ViedocRadioElement
                key={radio.id}
                checked={radio.checked}
                value={radio.value}
                name="new-version"
                className={radio.class}
                onChange={(e) => versionHandler(e)}
              >
                {radio.label}
              </ViedocRadioElement>
            ))}
          </div>
        );

      case APP_CONST.TEXT_UNLOCKDOC:
        if (settings.isreasonforunlockdocenabled) {
          return (
            <ViedocTextareaElement
              label={t("TMF.REVIEWPOPUP_REASON")}
              value={actionText}
              onChange={(e) => setActionText(e.target.value.trimStart())}
            />
          );
        } else {
          return;
        }

      case APP_CONST.TEXT_APPROVE:
        return;

      case APP_CONST.TEXT_DELETEDOC:
        return (
          <ViedocTextareaElement
            label={t("TMF.REVIEWPOPUP_REASON")}
            value={actionText}
            onChange={(e) => setActionText(e.target.value.trimStart())}
          />
        );
      default:
        return (
          <ViedocTextareaElement
            label={t("TMF.TEXT_COMMENT")}
            value={actionText}
            onChange={(e) => setActionText(e.target.value.trimStart())}
          />
        );
    }
  };

  const getDropdownValues = () => {
    switch (docDetailsList.status) {
      case APP_CONST.TEXT_AWAITINGREVIEW:
        const awaitingDropdownValues = filteredActionDropdownValues.map(
          (item) => {
            if (
              docDetailsList.writePermission &&
              docDetailsList.reviewPermission
            ) {
              if (
                (item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") &&
                  !selectedArtifactDetails?.isdeleted) ||
                item.label === t("TMF.REVIEWPOPUP_ADDNOTE") ||
                item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT") ||
                (item.label === t("TMF.TEXT_APPROVE") &&
                  !selectedArtifactDetails?.isdeleted)
              ) {
                item.disabled = false;
              } else if (
                item.label === t("TMF.BUTTON_CREATE_NEW_VERSION") ||
                (item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") &&
                  !selectedArtifactDetails?.isdeleted)
              ) {
                item.disabled = true;
              } else {
                item.displayAction = false;
              }
              return item;
            } else if (docDetailsList.writePermission) {
              if (item.label === t("TMF.BUTTON_CREATE_NEW_VERSION")) {
                item.disabled = true;
              } else if (
                item.label === t("TMF.REVIEWPOPUP_ADDNOTE") ||
                item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")
              ) {
                item.disabled = false;
              } else {
                item.displayAction = false;
              }
              return item;
            } else if (docDetailsList.reviewPermission) {
              if (
                (item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") &&
                  !selectedArtifactDetails?.isdeleted) ||
                (item.label === t("TMF.TEXT_APPROVE") &&
                  !selectedArtifactDetails?.isdeleted) ||
                item.label === t("TMF.REVIEWPOPUP_ADDNOTE")
              ) {
                item.disabled = false;
              } else if (
                item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") &&
                !selectedArtifactDetails?.isdeleted
              ) {
                item.disabled = true;
              } else {
                item.displayAction = false;
              }
              return item;
            }
          }
        );
        return awaitingDropdownValues;

      case APP_CONST.TEXT_FINALIZED:
        let finalizedDropdownValues;
        finalizedDropdownValues = filteredActionDropdownValues.map((item) => {
          if (
            docDetailsList.writePermission &&
            docDetailsList.reviewPermission
          ) {
            if (!latestDocVersion) {
              if (
                item.label === t("TMF.TEXT_APPROVE") ||
                item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") ||
                item.label === t("TMF.BUTTON_CREATE_NEW_VERSION")
              ) {
                item.disabled = true;
              } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else {
                item.displayAction = false;
              }
              return item;
            } else {
              if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else if (item.label === t("TMF.BUTTON_CREATE_NEW_VERSION")) {
                item.disabled = docDetailsList.islocked ? true : false;
              } else if (item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")) {
                item.disabled =
                  docShareCount.availableBindersCount > 0 ||
                  docDetailsList.islocked
                    ? true
                    : false;
                if (item.disabled && docShareCount.availableBindersCount > 0) {
                  item.title = t("TMF.TEXT_NOTALLOWEDDELETE");
                }
              } else if (
                item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") &&
                !selectedArtifactDetails?.isdeleted
              ) {
                item.disabled = false;
                item.displayAction = !docDetailsList.islocked;
              } else if (item.label === t("TMF.REVIEWPOPUP_UNLOCKDOCUMENT")) {
                item.displayAction = docDetailsList.islocked;
              } else if (
                item.label === t("TMF.TEXT_APPROVE") ||
                item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT")
              ) {
                item.disabled = true;
              } else {
                item.displayAction = false;
              }
              return item;
            }
          } else if (docDetailsList.writePermission) {
            if (!latestDocVersion) {
              if (item.label === t("TMF.BUTTON_CREATE_NEW_VERSION")) {
                item.disabled = true;
              } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else {
                item.displayAction = false;
              }
              return item;
            } else {
              if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else if (item.label === t("TMF.BUTTON_CREATE_NEW_VERSION")) {
                item.disabled = docDetailsList.islocked ? true : false;
              } else if (item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")) {
                item.disabled =
                  docShareCount.availableBindersCount > 0 ||
                  docDetailsList.islocked
                    ? true
                    : false;
                if (item.disabled && docShareCount.availableBindersCount > 0) {
                  item.title = t("TMF.TEXT_NOTALLOWEDDELETE");
                }
              } else {
                item.displayAction = false;
              }
              return item;
            }
          } else if (docDetailsList.reviewPermission) {
            if (!latestDocVersion) {
              if (
                item.label === t("TMF.TEXT_APPROVE") ||
                item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT")
              ) {
                item.disabled = true;
              } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else {
                item.displayAction = false;
              }
              return item;
            } else {
              if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else if (item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT")) {
                item.displayAction = !docDetailsList.islocked;
              } else if (item.label === t("TMF.REVIEWPOPUP_UNLOCKDOCUMENT")) {
                item.displayAction = docDetailsList.islocked;
              } else if (
                item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") ||
                item.label === t("TMF.TEXT_APPROVE")
              ) {
                item.disabled = true;
              } else {
                item.displayAction = false;
              }
              return item;
            }
          }
        });

        return finalizedDropdownValues;

      case APP_CONST.TEXT_FLAGGEDBYQC:
        const flaggedbyqcDropdownValues = filteredActionDropdownValues.map(
          (item) => {
            if (
              docDetailsList.writePermission &&
              docDetailsList.reviewPermission
            ) {
              if (
                (item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") &&
                  !selectedArtifactDetails?.isdeleted) ||
                item.label === t("TMF.REVIEWPOPUP_ADDNOTE") ||
                item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")
              ) {
                item.disabled = false;
              } else if (
                item.label === t("TMF.BUTTON_CREATE_NEW_VERSION") ||
                item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") ||
                item.label === t("TMF.TEXT_APPROVE")
              ) {
                item.disabled = true;
              } else {
                item.displayAction = false;
              }
              return item;
            } else if (docDetailsList.writePermission) {
              if (
                item.label === t("TMF.BUTTON_CREATE_NEW_VERSION") &&
                !selectedArtifactDetails?.isdeleted
              ) {
                item.disabled = true;
              } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
                item.disabled = false;
              } else if (item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")) {
                item.disabled = false;
              } else {
                item.displayAction = false;
              }
              return item;
            } else if (docDetailsList.reviewPermission) {
              if (
                (item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") &&
                  !selectedArtifactDetails?.isdeleted) ||
                item.label === t("TMF.REVIEWPOPUP_ADDNOTE")
              ) {
                item.disabled = false;
              } else if (
                (item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") &&
                  !selectedArtifactDetails?.isdeleted) ||
                (item.label === t("TMF.TEXT_APPROVE") &&
                  !selectedArtifactDetails?.isdeleted)
              ) {
                item.disabled = true;
              } else {
                item.displayAction = false;
              }
              return item;
            }
          }
        );
        return flaggedbyqcDropdownValues;

      case APP_CONST.TEXT_UNPUBLISHED:
        let unpublishedDropdownValues;
        unpublishedDropdownValues = filteredActionDropdownValues.map((item) => {
          if (
            docDetailsList.writePermission &&
            docDetailsList.reviewPermission
          ) {
            if (
              (item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") &&
                !selectedArtifactDetails?.isdeleted) ||
              (item.label === t("TMF.TEXT_APPROVE") &&
                !selectedArtifactDetails?.isdeleted) ||
              (item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") &&
                !selectedArtifactDetails?.isdeleted) ||
              (item.label === t("TMF.BUTTON_CREATE_NEW_VERSION") &&
                !selectedArtifactDetails?.isdeleted)
            ) {
              item.disabled = true;
            } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
              item.disabled = false;
            } else if (item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")) {
              item.disabled = !isNewVersionCreated ? false : true;
            } else {
              item.displayAction = false;
            }
            return item;
          } else if (docDetailsList.writePermission) {
            if (
              item.label === t("TMF.BUTTON_CREATE_NEW_VERSION") &&
              !selectedArtifactDetails?.isdeleted
            ) {
              item.disabled = true;
            } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
              item.disabled = false;
            } else if (item.label === t("TMF.REVIEWPOPUP_DELETEDOCUMENT")) {
              item.disabled = !isNewVersionCreated ? false : true;
            } else {
              item.displayAction = false;
            }
            return item;
          } else if (docDetailsList.reviewPermission) {
            if (
              (item.label === t("ADMIN.REVIEWPOPUP_ADDREVIEWCOMMENT") &&
                !selectedArtifactDetails?.isdeleted) ||
              (item.label === t("TMF.TEXT_APPROVE") &&
                !selectedArtifactDetails?.isdeleted) ||
              (item.label === t("TMF.REVIEWPOPUP_LOCKDOCUMENT") &&
                !selectedArtifactDetails?.isdeleted)
            ) {
              item.disabled = true;
            } else if (item.label === t("TMF.REVIEWPOPUP_ADDNOTE")) {
              item.disabled = false;
            } else {
              item.displayAction = false;
            }
            return item;
          }
        });
        return unpublishedDropdownValues;

      default:
        const unpublishedDropdownVal = filteredActionDropdownValues.filter(
          (item) => item.label === t("TMF.REVIEWPOPUP_ADDNOTE")
        );
        return unpublishedDropdownVal;
    }
  };

  const renderDropdown = () => {
    let mappingValues = getDropdownValues();
    mappingValues = [
      ...mappingValues,
      {
        value: "Select action",
        label: t("TMF.REVIEWPOPUP_SELECTACTION"),
        id: 0,
      },
    ];

    return (
      <ViedocSelectElement
        size="small"
        value={selectedAction}
        onChange={(e) => handleSelectedAction(e)}
      >
        {mappingValues.map((value) => (
          <ViedocMenuItemElement
            key={value.id}
            value={value.value}
            title={value.title || ""}
            disabled={value.disabled || false}
            selected={value.value === "Select action" ? true : null}
            hidden={value.value === "Select action" || !value.displayAction}
          >
            {value.label}
          </ViedocMenuItemElement>
        ))}
      </ViedocSelectElement>
    );
  };

  const renderSelectDocument = () => {
    return (
      <section className="document-select-option">
        <label>{t("TMF.REVIEWPOPUP_SELECTACTION")}</label>
        <div>{renderDropdown()}</div>
      </section>
    );
  };

  const renderSelectComment = () => {
    return (
      actionListArray.includes(selectedAction) && (
        <section className="select-comment">
          <div
            style={{
              padding:
                selectedAction === APP_CONST.TEXT_CREATE_NEW_VERSION
                  ? "0px"
                  : "15px 0px",
            }}
          >
            {getActionField()}
          </div>
        </section>
      )
    );
  };

  const getActionButtonText = () => {
    switch (selectedAction) {
      case APP_CONST.TEXT_LOCKDOC:
        setActionText(" ");
        return t("TMF.REVIEWPOPUP_LOCKDOCUMENT");

      case APP_CONST.TEXT_UNLOCKDOC:
        !settings.isreasonforunlockdocenabled && setActionText(" ");
        return t("TMF.REVIEWPOPUP_UNLOCKDOCUMENT");

      case APP_CONST.TEXT_APPROVE:
        setActionText(" ");
        return t("TMF.TEXT_APPROVE");

      case APP_CONST.TEXT_DELETEDOC:
        return t("TMF.REVIEWPOPUP_DELETEDOCUMENT");
      case APP_CONST.TEXT_ADDNOTE:
        return t("TMF.REVIEWPOPUP_SAVE");
      default:
        return t("TMF.REVIEWPOPUP_READY");
    }
  };

  function isDisabled() {
    switch (selectedAction) {
      case APP_CONST.TEXT_CREATE_NEW_VERSION:
        if (copyVersion || uploadVersion) {
          return false;
        }
        return true;
      default:
        return !actionText;
    }
  }

  const renderFooter = () => {
    return (
      <div className="d-flex justfy-content-flex-end pad-20 bt-2">
        <ViedocButtonElement
          disabled={isDisabled()}
          size="small"
          variant="success"
          class="mr-10"
          onClick={() => actionHandler()}
          title={getActionButtonText()}
        >
          {getActionButtonText()}
        </ViedocButtonElement>
      </div>
    );
  };

  return (
    <ViedocDialogElement
      size="small"
      open
      preventCloseByClick
      class="action-modal"
      id="document-action"
      onHide={(e) => onHide(e)}
    >
      <header slot="header">{t("TMF.TEXT_RECORDACTIONS")}</header>

      {renderSelectDocument()}

      {renderSelectComment()}

      {renderFooter()}
    </ViedocDialogElement>
  );
};

export default DocumentActionModal;
